import React from 'react';

export const ButtonNext = ({ steps, activeStep, dispatch, addToCart, stateCameraWizard }) => {
  let buttonLabel, buttonAction: string;

  if (steps[activeStep] && steps[activeStep].button_primary) {
    buttonLabel = steps[activeStep].button_primary.label;
    buttonAction = steps[activeStep].button_primary.action;
  } else {
    buttonLabel = "Next";
    buttonAction = "next"
  }

  const nextIndex = activeStep + 1;

  if (buttonAction === "next" && nextIndex < steps.length) {
    return (
      <button
        onClick={() => dispatch({
          type: "activeStep",
          value: nextIndex
        })}
        className="customizer-cta font-medium rounded uppercase text-sm w-11/12 px-8 py-[1.125rem]">
        {buttonLabel}
      </button>
    )
  } else if (buttonAction === "start_measurement") {
    // if (stateCameraWizard.capSize && stateCameraWizard.laceTint) {
    //   return (
    //     <button
    //       onClick={() => dispatch({
    //         type: "activeStep",
    //         value: nextIndex
    //       })}
    //       className="customizer-cta font-medium rounded uppercase text-sm w-full px-3 py-[1.125rem]">
    //       Next
    //     </button>
    //   )
    // }
    return (
      <button
        onClick={() => dispatch({
          type: "cameraIntro",
          value: true
        })}
        className="customizer-cta font-medium rounded uppercase text-sm px-8 w-11/12 py-[1.125rem]">
        {buttonLabel}
      </button>
    )
  } else if (buttonAction === "add_to_cart") {
    return (
      <div>
      <button id="addToCart" onClick={addToCart} className="customizer-cta font-medium rounded uppercase w-11/12 text-sm px-8 py-[1.125rem]">
        {buttonLabel}
      </button>
      <br></br>
      </div>
    )
  }
};